












































import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";

/**
 * Utils
 */
import classes from "@/config/wow/classes";
import * as externalLinks from "@/config/external-links";
import * as imageLinks from "@/config/image-links";
import armorTypes from "@/config/wow/armor-types";

import { teamUrl } from "@/utils/url-helpers";

/**
 * Components
 */
import GroupCard from "@/components/_global/GroupCard.vue";

/**
 * API
 */
import rostersAPI from "@/api/rosters";
import { GetOneTeamResponse } from "@/api/teams/get-one-team.response";
import { GetRostersResponse } from "@/api/rosters/get-rosters.response";
import DataFetcher from "@/components/_global/DataFetcher.vue";


/**
 * Types
 */


/**
 * VueX Modules
 */
const teamModule = namespace("team");

/**
 * Roster's list page.
 */
@Component({
	components: {
		DataFetcher,
		GroupCard
	}
})
export default class RostersListPage extends Vue {
	/// Injections
	classes = classes;
	externalLinks = externalLinks;
	imageLinks = imageLinks;
	armorTypes = armorTypes;
	teamUrl = teamUrl;

	/// Attributes
	isLoading = false;
	rosters: GetRostersResponse.Roster[] | null = null;

	/// VueX Modules
	@teamModule.State("team")
	currentTeam!: GetOneTeamResponse;

	/// Methods
	async created() {
	}

	async fetch() {
		this.rosters = await rostersAPI.fetchRosters(this.currentTeam.id);
	}
}
